"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// eslint-disable-next-line @typescript-eslint/no-unused-vars

var NPSRun = function NPSRun() {
  setTimeout(function () {
    if (typeof window.QSI !== 'undefined') {
      window.QSI.API.run();
    }
  }, 2000);
};
var _default = exports.default = NPSRun;